export default __webpack_public_path__ + "static/media/user.0511d244.svg";